import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter'; // selbst-gehostete Webschrift (offline, kein CDN)
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { GlobalStyles } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import kinpointTheme from "./theme/theme";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <ThemeProvider theme={kinpointTheme} defaultMode="light">
      {/* App-weite Grundstyles — theme-aware, damit der Dark Mode (D3)
          Body-Grund, Rollbalken und native Controls mitzieht */}
      <GlobalStyles styles={(theme) => ({
        body: {
          backgroundColor: theme.palette.background.default,
          // D4: hauchzarter Farb-Wash (Indigo oben links, Teal unten rechts)
          // gibt dem flachen Grund Tiefe — bewusst KEIN Muster/Noise
          backgroundImage: theme.palette.mode === 'dark'
            ? 'radial-gradient(1100px 520px at 18% -8%, rgba(129,140,248,0.07), transparent 60%), radial-gradient(900px 520px at 105% 110%, rgba(78,200,192,0.05), transparent 60%)'
            : 'radial-gradient(1100px 520px at 18% -8%, rgba(79,70,229,0.05), transparent 60%), radial-gradient(900px 520px at 105% 110%, rgba(14,158,151,0.04), transparent 60%)',
          backgroundAttachment: 'fixed',
          // ohne CssBaseline erbt Text sonst das Browser-Schwarz
          color: theme.palette.text.primary,
          // Tabellenziffern app-weit: KPIs und Spalten springen nicht
          fontVariantNumeric: 'tabular-nums',
          // native Scrollbars/Inputs folgen dem Modus
          colorScheme: theme.palette.mode,
        },
        // D4: konsequente Fokus-Ringe für Tastatur-Navigation
        '*:focus-visible': {
          outline: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(129,140,248,0.7)' : 'rgba(79,70,229,0.55)'}`,
          outlineOffset: 2,
        },
        // D4: Bewegung respektiert die Systemeinstellung
        '@media (prefers-reduced-motion: reduce)': {
          '*, *::before, *::after': {
            transitionDuration: '0.01ms !important',
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            scrollBehavior: 'auto !important',
          },
        },
        '*::-webkit-scrollbar': { width: 10, height: 10 },
        '*::-webkit-scrollbar-thumb': {
          background: theme.palette.tokens.scrollThumb,
          borderRadius: 8, border: '2px solid transparent', backgroundClip: 'content-box',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: theme.palette.tokens.scrollThumbHover, backgroundClip: 'content-box',
        },
        // Fix for Safari Bug: (Visual bug on outlined label in Safari #46891)
        // https://github.com/mui/material-ui/issues/46891
        '@supports (-webkit-appearance: none)': {
          '.MuiOutlinedInput-notchedOutline legend': {
            visibility: 'visible !important',
          },
        },
      })} />

      <div style={{ minHeight: '100vh' }}>
        <App />
      </div>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
